import axiosInstance from "../../utils/axiosCompany";

export const ListSalesReport = async (values) => {
    return await axiosInstance().post("company/report/sales-report-list", values);
}
export const ListCustomerReport = async (values) => {
    return await axiosInstance().post("company/report/customer-report-list", values);
}
export const ListPrimaryCategoryReport = async (values) => {
    return await axiosInstance().post("company/report/primary-category-report-list", values);
}
export const ListInventoryReport = async (values) => {
    return await axiosInstance().post("company/report/inventory-report-list", values);
}
export const ListPaymentReport = async (values) => {
    return await axiosInstance().post("company/report/payment-report-list", values);
}
export const StockMovementReport = async (values) => {
    return await axiosInstance().post("company/report/stock-movement-report-list", values);
}
export const ListItemCostCalculationReport = async (values) => {
    return await axiosInstance().post("company/report/item-cost-calculation-report-list", values);
}

//common APIs For ERP
export const erpChangeStatus = async () => {
    return await axiosInstance().post("company/report/erp-enable-change-status");
}
export const InventoryEnd = async (values) => {
    return await axiosInstance().post("company/report/sync-to-erp-store-manager", values);
}
export const RegenerateAll = async (values) => {
    return await axiosInstance().post("company/report/erp-regenerate-all", values);
}

//ERP Sales API
export const erpList = async (values) => {
    return await axiosInstance().post("company/report/erp-report", values);
}
//ERP Payment API
export const erpPaymentList = async (values) => {
    return await axiosInstance().post("company/report/erp-payment-report", values);
}
//ERP commission API
export const erpCommissionsList = async (values) => {
    return await axiosInstance().post("company/report/erp-commissions-report", values);
}
